import { render, staticRenderFns } from "./switch_page.vue?vue&type=template&id=13cda94e&scoped=true"
import script from "./switch_page.vue?vue&type=script&lang=js"
export * from "./switch_page.vue?vue&type=script&lang=js"
import style0 from "./switch_page.vue?vue&type=style&index=0&id=13cda94e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cda94e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13cda94e')) {
      api.createRecord('13cda94e', component.options)
    } else {
      api.reload('13cda94e', component.options)
    }
    module.hot.accept("./switch_page.vue?vue&type=template&id=13cda94e&scoped=true", function () {
      api.rerender('13cda94e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sys/switch_page.vue"
export default component.exports